/// <reference path="../../styles/theme.d.ts" />
import {styled} from '@mui/material/styles';
import TextField, {TextFieldProps} from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import {Search, Clear} from '@mui/icons-material';
import {useState, ChangeEvent} from 'react';

export interface SearchFieldProps extends Omit<TextFieldProps, 'onChange'> {
  onChange?: (value: string) => void;
  placeholder?: string;
}

const StyledSearchField = styled(TextField, {
  name: 'SearchField',
  shouldForwardProp: (prop) => prop !== 'placeholder',
})<TextFieldProps>(({theme}) => ({
  marginBottom: theme.spacing(3),
  // Apply theme overrides
  ...theme.components?.SearchField?.styleOverrides?.root,
}));

export default function SearchField({
  onChange: onChangeProp,
  placeholder = 'Search courses...',
  sx,
  ...props
}: SearchFieldProps) {
  const [searchQuery, setSearchQuery] = useState('');

  const handleChange = (value: string) => {
    setSearchQuery(value);
    onChangeProp?.(value);
  };

  const handleClear = () => {
    handleChange('');
  };

  const handleTextFieldChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const target = e.target as HTMLInputElement;
    handleChange(target.value);
  };

  return (
    <StyledSearchField
      fullWidth
      placeholder={placeholder}
      value={searchQuery}
      onChange={handleTextFieldChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
        endAdornment:
          searchQuery.length > 0 ? (
            <InputAdornment position="end">
              <Clear onClick={handleClear} sx={{cursor: 'pointer', '&:hover': {opacity: 0.7}}} />
            </InputAdornment>
          ) : null,
      }}
      sx={sx}
      {...props}
    />
  );
}
